import styled from 'styled-components';
import { bg } from '@lendi-ui/color';
import { mb, mt, mx, py } from '@lendi-ui/spacing';
import { heading } from '@lendi-ui/typography';
import { Article, FigureLink } from '../ArticleCard/index.style';

export const OuterWrapper = styled.div`
  ${py('lg')}
  ${bg('secondary.25')}
`;

export const InnerWrapper = styled.div`
  ${mx({ mobile: 'md', desktop: 'xxs' })}
  ${Article} ${FigureLink} {
    height: 10rem;
  }
`;

export const Title = styled.h3`
  ${heading({ size: 'sm', color: 'secondary.500' })}
  ${mt('nil')}
  ${mb('sm')}
`;
